exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._31UpMnmKwGQCPKm4dDFECT{display:flex;justify-content:center;width:100%}._18LRzXoR2GukntCwGJIHJo{flex:1;align-self:flex-start}._1sHCwUVuoPljBkHvSzj8Xd{flex:2;line-height:100px;text-align:center}._2TyxykxGUnKhD-K3NuBzGX{font-size:24px;margin-top:12px;margin-left:10px}._2TyxykxGUnKhD-K3NuBzGX>:first-child{margin-bottom:5px}._1qfUB7bYz8EiOQx6RTb_Vk{color:#e3e5e5;height:25px;margin-bottom:-18px}._1uEzTKIeJ43kO_g3obG_RY{color:#8dc63f}._1rXtoaoHWS_3MgtNamMxgh{color:#be1e2d}", ""]);

// exports
exports.locals = {
	"number": "_31UpMnmKwGQCPKm4dDFECT",
	"aside": "_18LRzXoR2GukntCwGJIHJo",
	"value": "_1sHCwUVuoPljBkHvSzj8Xd",
	"trendIndicators": "_2TyxykxGUnKhD-K3NuBzGX",
	"trendIcon": "_1qfUB7bYz8EiOQx6RTb_Vk",
	"trendGood": "_1uEzTKIeJ43kO_g3obG_RY",
	"trendBad": "_1rXtoaoHWS_3MgtNamMxgh"
};


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/graylog-project-cli-release/.repos/graylog2-server/graylog2-web-interface/node_modules/css-loader!/var/lib/jenkins/workspace/graylog-project-cli-release/.repos/graylog2-server/graylog2-web-interface/src/components/visualizations/NumericVisualization.css
// module id = 635
// module chunks = 0